import React, { createContext, useState, useEffect } from "react";
import apiService from "../services/apiService";
import configService from "../services/configService";

export const DestinazioneContext = createContext();

export const DestinazioneProvider = ({ children }) => {
  const [destinazione, setDestinazione] = useState(null);
  const [isDestinazioneLoggedIn, setIsDestinazioneLoggedIn] = useState(false);
  const [dayActivationFlags, setDayActivationFlags] = useState({});

  // Recupera i dati salvati in localStorage all'avvio
  useEffect(() => {
    const savedDestinazione = localStorage.getItem("destinazione");
    const savedDayFlags = localStorage.getItem("dayActivationFlags");
    
    if (savedDestinazione) {
      try {
        const parsedDestinazione = JSON.parse(savedDestinazione);
        setDestinazione(parsedDestinazione);
        setIsDestinazioneLoggedIn(true);
        
        // Prima controlla se ci sono flag salvati separatamente (hanno priorità)
        if (savedDayFlags) {
          try {
            const parsedDayFlags = JSON.parse(savedDayFlags);
            setDayActivationFlags(parsedDayFlags);
            console.log("[DestinazioneContext] Usando savedDayFlags:", parsedDayFlags);
          } catch (error) {
            console.error("[DestinazioneContext] Errore nel parsing dei flag giorni salvati:", error);
            localStorage.removeItem("dayActivationFlags");
            // Fallback ai dati della destinazione
            if (parsedDestinazione.datiDestinazione) {
              const flags = {
                lunedi: parsedDestinazione.datiDestinazione.lun_act || 0,
                martedi: parsedDestinazione.datiDestinazione.mar_act || 0,
                mercoledi: parsedDestinazione.datiDestinazione.mer_act || 0,
                giovedi: parsedDestinazione.datiDestinazione.gio_act || 0,
                venerdi: parsedDestinazione.datiDestinazione.ven_act || 0,
                sabato: parsedDestinazione.datiDestinazione.sab_act || 0,
                domenica: parsedDestinazione.datiDestinazione.dom_act || 0,
                speciale: parsedDestinazione.datiDestinazione.spec_act || 0
              };
              setDayActivationFlags(flags);
              localStorage.setItem("dayActivationFlags", JSON.stringify(flags));
            }
          }
        } else {
          // Se non ci sono flag salvati, estrai dalla destinazione
          if (parsedDestinazione.datiDestinazione) {
            const flags = {
              lunedi: parsedDestinazione.datiDestinazione.lun_act || 0,
              martedi: parsedDestinazione.datiDestinazione.mar_act || 0,
              mercoledi: parsedDestinazione.datiDestinazione.mer_act || 0,
              giovedi: parsedDestinazione.datiDestinazione.gio_act || 0,
              venerdi: parsedDestinazione.datiDestinazione.ven_act || 0,
              sabato: parsedDestinazione.datiDestinazione.sab_act || 0,
              domenica: parsedDestinazione.datiDestinazione.dom_act || 0,
              speciale: parsedDestinazione.datiDestinazione.spec_act || 0
            };
            setDayActivationFlags(flags);
            localStorage.setItem("dayActivationFlags", JSON.stringify(flags));
            console.log("[DestinazioneContext] Usando flags dalla destinazione:", flags);
          }
        }
      } catch (error) {
        console.error("[Login Destinazione] Errore nel parsing dei dati salvati:", error);
        localStorage.removeItem("destinazione");
        localStorage.removeItem("dayActivationFlags");
      }
    }
  }, []);

  const persistAdminRole = (isAdmin) => {
    localStorage.setItem("isDefaultUser", isAdmin ? "true" : "false");
    localStorage.setItem("isSuperuser", isAdmin ? "true" : "false");
  };

  // Login destinazione
  const loginDestinazione = async (destlogin, destpsw, navigateCallback = null, options = {}) => {

    try {
      console.log("[Login Destinazione] Inizio login per:", destlogin);
      
      // IMPORTANTE: Rinnova il CSRF token prima del login destinazione
      try {
        console.log("[Login Destinazione] Rinnovo CSRF token...");
        await apiService("/sanctum/csrf-cookie", "GET");
        
        // Piccolo delay per assicurare che il cookie sia settato
        await new Promise(resolve => setTimeout(resolve, 200));
      } catch (csrfError) {
        console.warn("[Login Destinazione] Errore nel rinnovo CSRF, proseguo:", csrfError);
      }

      // Ora fai il login destinazione
      console.log("[Login Destinazione] Invio credenziali...");
      
      const response = await apiService("/applicazioni/panificatori/login", "POST", {
        destlogin,
        destpsw,
      });

      console.log("[Login Destinazione] Risposta completa:", response);

      if (response && response.data) {

        const data = response.data;
        console.log("[Login Destinazione] Dati ricevuti:", data);

        // Accedi da lista destinazioni: l'amministratore resta tale, altrimenti
        // il login sulla destinazione cliente azzera isDefaultUser e toglie il menu extra.
        const keepAdminRole =
          options?.preserveAdminRole === true &&
          localStorage.getItem("isDefaultUser") === "true";
        
        // Controllo speciale: se destlogin e destpsw corrispondono a un indirizzo
        // e il risultato ha data.primario = true, chiama l'API def_clie_interno e apri pagina destinazioni
    
        if (data.datiDestinazione.primario && 
            typeof data.datiDestinazione.primario === 'string' && 
            data.datiDestinazione.primario.length === 6) {

          console.log("[Login Destinazione] Destinazione primaria rilevata, controllo cliente interno...");
          
          try {
            // Chiama l'API per ottenere il cliente interno di default
            const clienteInternoResponse = await configService.getDefaultClienteInterno();
            console.log("[Login Destinazione] Cliente interno ricevuto:", clienteInternoResponse);
            
            // Estrai substring: dalla posizione 3, prendi 4 caratteri
            const primarioSubstring = data.codiceCliente ;
            console.log("[Login Destinazione] Substring primario (pos 3-6):", primarioSubstring);
    
            // Confronta i valori
            if (clienteInternoResponse && clienteInternoResponse.toString() === primarioSubstring) {
              console.log("[Login Destinazione] Match trovato! Navigazione verso destinazioni...");
              
              persistAdminRole(true);
              console.log("[Login Destinazione] isDefaultUser settato a true");
              
              // Salva comunque i dati della destinazione
              setDestinazione(data);
              setIsDestinazioneLoggedIn(true);
              localStorage.setItem("destinazione", JSON.stringify(data));
              
              // Estrai e salva i flag di attivazione giorni se disponibili
              if (data.datiDestinazione) {
                const flags = {
                  lunedi: data.datiDestinazione.lun_act || 0,
                  martedi: data.datiDestinazione.mar_act || 0,
                  mercoledi: data.datiDestinazione.mer_act || 0,
                  giovedi: data.datiDestinazione.gio_act || 0,
                  venerdi: data.datiDestinazione.ven_act || 0,
                  sabato: data.datiDestinazione.sab_act || 0,
                  domenica: data.datiDestinazione.dom_act || 0,
                  speciale: data.datiDestinazione.spec_act || 0
                };
                setDayActivationFlags(flags);
                localStorage.setItem("dayActivationFlags", JSON.stringify(flags));
              }

              if (data.codiceDestinazione) {
                localStorage.setItem("codiceDestinazione", data.codiceDestinazione);
              }
              if (data.codiceCliente) {
                localStorage.setItem("codiceCliente", data.codiceCliente);
              }
              
              // Se abbiamo una funzione di navigazione, apri la pagina delle destinazioni
              if (navigateCallback && typeof navigateCallback === 'function') {
                console.log("[Login Destinazione] Apertura pagina destinazioni...");
                navigateCallback('/destinazioni');
                return { success: true, navigatedToDestinazioni: true };
              }
            } else if (keepAdminRole) {
              persistAdminRole(true);
              console.log("[Login Destinazione] Destinazione cliente: ruolo amministratore conservato");
            } else {
              console.log("[Login Destinazione] Nessun match - Cliente interno:", clienteInternoResponse, "Substring primario:", primarioSubstring);
              persistAdminRole(false);
              console.log("[Login Destinazione] isDefaultUser settato a false");
            }
          } catch (clienteInternoError) {
            console.error("[Login Destinazione] Errore nel recupero cliente interno:", clienteInternoError);
            // Prosegui comunque con il login normale
          }
        }
        
        setDestinazione(data);
        setIsDestinazioneLoggedIn(true);
        
        // Salva i dati nel localStorage
        localStorage.setItem("destinazione", JSON.stringify(data));
        
        // Estrai e salva i flag di attivazione giorni se disponibili
        // datiDestinazione può includere anche: abilita_blocco (0/1), orarioblocco_dest (override ORARIOBLOCCO per non-admin)
        if (data.datiDestinazione) {
          const flags = {
            lunedi: data.datiDestinazione.lun_act || 0,
            martedi: data.datiDestinazione.mar_act || 0,
            mercoledi: data.datiDestinazione.mer_act || 0,
            giovedi: data.datiDestinazione.gio_act || 0,
            venerdi: data.datiDestinazione.ven_act || 0,
            sabato: data.datiDestinazione.sab_act || 0,
            domenica: data.datiDestinazione.dom_act || 0,
            speciale: data.datiDestinazione.spec_act || 0
          };
          setDayActivationFlags(flags);
          localStorage.setItem("dayActivationFlags", JSON.stringify(flags));
        }
        
        // Salva i codici solo se esistono
        if (data.codiceDestinazione) {
          localStorage.setItem("codiceDestinazione", data.codiceDestinazione);
        }
        if (data.codiceCliente) {
          localStorage.setItem("codiceCliente", data.codiceCliente);
        }
        
        // Se non è stato già settato il flag isDefaultUser, settalo come false (utente normale)
        if (!localStorage.getItem("isDefaultUser")) {
          persistAdminRole(false);
          console.log("[Login Destinazione] isDefaultUser settato a false (utente normale)");
        }
        
        return { success: true, navigatedToDestinazioni: false };
      } else {
        console.error("[Login Destinazione] Errore: Risposta non valida", response);
        throw new Error("Credenziali non valide");
      }
    } catch (error) {
      console.error("[Login Destinazione] Errore completo:", error);
      
      // Log dettagliato per debug
      if (error.response) {
        console.error("[Login Destinazione] Status:", error.response.status);
        console.error("[Login Destinazione] Status Text:", error.response.statusText);
        console.error("[Login Destinazione] Response Data:", error.response.data);
        console.error("[Login Destinazione] Response Headers:", error.response.headers);
        
        // Se è un errore 419 (CSRF), suggerisci di ricaricare la pagina
        if (error.response.status === 419) {
          console.error("[Login Destinazione] Errore CSRF token. Potrebbe essere necessario ricaricare la pagina.");
        }
      }
      
      return { success: false, navigatedToDestinazioni: false };
    }
  };

  // Logout destinazione
  const logoutDestinazione = () => {
    setDestinazione(null);
    setIsDestinazioneLoggedIn(false);
    setDayActivationFlags({});
    
    // Pulisci la sessione destinazione, non le credenziali «Ricordami»
    localStorage.removeItem("destinazione");
    localStorage.removeItem("dayActivationFlags");
    localStorage.removeItem("codiceDestinazione");
    localStorage.removeItem("codiceCliente");
    localStorage.removeItem("isDefaultUser");
    localStorage.removeItem("isSuperuser");
    
    console.log("[Login Destinazione] Logout completato");
  };

  // Funzione per aggiornare i flag di attivazione dei giorni in tempo reale
  const updateDayActivationFlag = (selectedDay, newFlagValue) => {
    console.log(`[DestinazioneContext] Aggiornamento flag per ${selectedDay}: ${newFlagValue}`);
    
    // Aggiorna lo stato del context
    setDayActivationFlags(prevFlags => ({
      ...prevFlags,
      [selectedDay]: newFlagValue
    }));
    
    // Aggiorna anche i dati della destinazione se disponibili
    if (destinazione?.datiDestinazione) {
      const dayMapping = {
        'lunedi': 'lun_act',
        'martedi': 'mar_act',
        'mercoledi': 'mer_act',
        'giovedi': 'gio_act',
        'venerdi': 'ven_act',
        'sabato': 'sab_act',
        'domenica': 'dom_act'
      };
      
      const dayField = dayMapping[selectedDay];
      if (dayField) {
        const updatedDestinazione = {
          ...destinazione,
          datiDestinazione: {
            ...destinazione.datiDestinazione,
            [dayField]: newFlagValue
          }
        };
        
        setDestinazione(updatedDestinazione);
        
        // Aggiorna localStorage
        localStorage.setItem("destinazione", JSON.stringify(updatedDestinazione));
        
        // Aggiorna anche i dayActivationFlags in localStorage
        const updatedFlags = { ...dayActivationFlags, [selectedDay]: newFlagValue };
        localStorage.setItem("dayActivationFlags", JSON.stringify(updatedFlags));
        
        console.log(`[DestinazioneContext] Aggiornato localStorage: ${selectedDay} -> ${dayField} = ${newFlagValue}`);
      }
    }
  };

  return (
    <DestinazioneContext.Provider
      value={{
        destinazione,
        isDestinazioneLoggedIn,
        dayActivationFlags,
        loginDestinazione,
        logoutDestinazione,
        updateDayActivationFlag, // Aggiungi la nuova funzione
      }}
    >
      {children}
    </DestinazioneContext.Provider>
  );
};